<script>
  import GNavBar from '@/components/GNavBar.vue'
  import { getCleanDate } from '@/utils/index.js'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'SetupReviewPage',
    created() {
      this.$store.dispatch('getProjects')
      this.$store.dispatch('setCurrentProjectByID', {
        id: parseInt(this.$route.params.projectId)
      })
      this.$store.dispatch('getUserList')
    },
    data() {
      return {
        submission: {
          project_id: parseInt(this.$route.params.projectId),
          peerReviewerEnrolledInDevSite: null,
          peer_reviewer_email: null,
          peer_reviewer_full_name: null,
          ofdit_reviewer_id: null,
          without_peer_reviewer: false
        }
      }
    },
    validations: {
      submission: {
        ofdit_reviewer_id: { required }
      }
    },
    computed: {
      currentProject() {
        return this.$store.getters.currentProject
      },
      currentUser() {
        return this.$store.getters.currentUser
      },
      ofditStaff() {
        return this.$store.getters.ofditStaff
      }
    },
    components: {
      GNavBar
    },
    methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v.submission[name]
        return $dirty ? !$error : null
      },
      getCleanDate,
      async onSubmit() {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        } else {
          try {
            this.submission.userToken = this.currentUser.token
            this.$store.dispatch('cr_createReview', this.submission)
            this.$root.$bvToast.toast('Successfully created review.', {
              title: 'Success',
              autoHideDelay: 1000,
              toaster: 'b-toaster-top-center',
              variant: 'success'
            })
            this.$router.go(-1)
          } catch (err) {
            this.$root.$bvToast.toast(
              `Error creating review
      ${err.message}. Please contact OFDIT.`,
              {
                title: 'Error',
                toaster: 'b-toaster-top-center',
                variant: 'danger'
              }
            )
          }
        }
      }
    }
  }
</script>

<template>
  <div>
    <GNavBar></GNavBar>
    <h1 class="mt-5 pt-5">Setup course review</h1>
    <hr />
    <b-row align-h="center">
      <b-col>
        <h3 class="mb-n1">
          {{ currentProject.course }}
        </h3>
        <h5>
          <span class="text-muted"
            >{{ currentProject.id }}:
            {{ currentProject.developer_lastname }}</span
          >
        </h5>
        <b-card>
          <b-table-simple>
            <b-thead>
              <b-tr>
                <b-th>Project record</b-th>
                <b-th>Delivery date</b-th>
                <b-th>Target launch semester</b-th>
                <b-th>Academic/Program director</b-th>
                <b-th>OFDIT lead</b-th>
              </b-tr>
            </b-thead>

            <b-tbody>
              <b-td>
                <b-link
                  :to="{
                    name: 'projects',
                    params: { id: $route.params.projectId }
                  }"
                  >{{ $route.params.projectId }}</b-link
                >
              </b-td>
              <b-td>{{ getCleanDate(currentProject.delivery_date) }}</b-td>
              <b-td>{{ currentProject.target_launch_semester }}</b-td>
              <b-td
                >{{ currentProject.academic_director }}
                <b-link
                  :href="`mailto:${currentProject.academic_director_email}`"
                >
                  <b-icon icon="envelope"></b-icon>
                </b-link>
              </b-td>
              <b-td
                >{{ currentProject.ofdit_lead }}
                <b-link :href="`mailto:${currentProject.ofdit_lead_email}`">
                  <b-icon icon="envelope"></b-icon>
                </b-link>
              </b-td>
            </b-tbody>
          </b-table-simple>
          <hr />
          <b-alert show variant="primary">
            To setup a course review for this project, please provide OFDIT and
            Peer Reviewer details below and then select "Submit." Once this form
            is submitted, emails will be sent to each reviewer with an access
            link for the review.
          </b-alert>
          <b-form @submit.prevent="onSubmit">
            <div class="w-50">
              <b-form-group id="fg-ofdit_reviewer" label="OFDIT reviewer"
                ><b-form-select
                  v-model="submission.ofdit_reviewer_id"
                  :options="ofditStaff"
                  :state="validateState('ofdit_reviewer_id')"
                  value-field="id"
                  text-field="full_name"
                ></b-form-select>
                <b-form-invalid-feedback
                  >Must select an OFDIT reviewer
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <b-form-row>
              <b-col>
                <b-form-group
                  id="fg-peer_reviewer_full_name"
                  label="Peer reviewer full name"
                >
                  <b-form-input
                    v-model="submission.peer_reviewer_full_name"
                    id="peer-name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="fg-peer_reviewer_email"
                  label="Peer reviewer email"
                >
                  <b-form-input
                    type="email"
                    v-model="submission.peer_reviewer_email"
                    id="peer-email"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="6">
                <b-form-group
                  for="cb-withoutPeerReviewer"
                  label="Missing peer reviewer"
                >
                  <b-form-checkbox
                    id="cb-withoutPeerReviewer"
                    v-model="submission.without_peer_reviewer"
                  >
                    A peer reviewer has not yet been assigned to this review. I
                    will make a Data Shop support request when I have one, and
                    acknowledge this may delay the processing of this review.
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  for="cb-peerReviewerEnrolledInDevSite"
                  label="Enrollment in dev site"
                >
                  <b-form-checkbox
                    id="cb-peerReviewerEnrolledInDevSite"
                    v-model="submission.peerReviewerEnrolledInDevSite"
                  >
                    If a peer reviewer has been entered for this review, I
                    acknowledge that that reviewer has been enrolled into the
                    dev site listed for this project.
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-button class="float-right" type="submit" variant="primary"
              >Submit</b-button
            >
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped></style>
